var $class="se2--content-product-blocks-with-intro",$name="ContentProductBlocksWithIntro",$path="app/components/ContentProductBlocksWithIntro/index.js",$this={$class,$name,$path,};import initializeSliderForProductCards from 'app/components/utilities/initializeSliderForProductCards';

import shell from 'app/modules/shell';

import 'app/partials/image';

export default shell.registerComponent($this, ({ addEventListener, mount }) => {
  mount((element) => {
    const slider = initializeSliderForProductCards(addEventListener, element, false);
    addEventListener(window, 'resize', slider?.onResize);
  });
});
